import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  body: {
    Body: {
      backgroundColor: "#000000",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#292739",
    justifyContent: "space-between",
    paddingTop: "30px",
    paddingBottom: "10px",
    width: "100%"
  },
  headerTitle: {
    fontSize: "20px",
    color: "#ffffff",
    boxShadow: "unset",
    paddingLeft: "20px",
    paddingRight: "20px"
  },
  title: {
    backgroundColor: "#292739",
    paddingLeft: "20px",
    color: "#c1c1c1"
  },
  content: {
    backgroundColor: "#292739",
    padding: "20px",
    gap: "20px",
    display: "flex",
    flexDirection: "column"
  },
  footer: {
    backgroundColor: "#292739",
    color: "#c1c1c1",
    textAlign: "center",
    padding: "20px"
  }
}));

export default useStyles;
